import planCopy from "./plan-copy.json";
import overrides from "./locales/overrides.json";

import { languageOptions } from "./languages";
export { languageOptions } from "./languages";
// Each locale is its own static chunk; English visitors do not download all packs.
export const localeLoaders = {
  es: () => import("./locales/es.json"),
  fr: () => import("./locales/fr.json"),
  de: () => import("./locales/de.json"),
  ar: () => import("./locales/ar.json"),
  hi: () => import("./locales/hi.json"),
  zh: () => import("./locales/zh.json"),
  ru: () => import("./locales/ru.json"),
  id: () => import("./locales/id.json"),
  ja: () => import("./locales/ja.json"),
  ur: () => import("./locales/ur.json"),
};
export const bundles = {};
const pending = {};
export const languageIsLoaded = (code) =>
  code === "en" || code === "pt" || !!bundles[code];
export function loadLanguage(code) {
  if (languageIsLoaded(code)) return Promise.resolve();
  if (!localeLoaders[code])
    return Promise.reject(new Error("Unknown language"));
  if (!pending[code]) {
    pending[code] = localeLoaders[code]()
      .then((module) => {
        bundles[code] = module.default || module;
        delete pending[code];
      })
      .catch((error) => {
        delete pending[code];
        throw error;
      });
  }
  return pending[code];
}
export function translate(en, pt, language = "en") {
  if (language === "pt") return planCopy[en] || pt || en;
  if (language === "en") return en;
  return overrides[en]?.[language] || bundles[language]?.[en] || en;
}
